<template>
  <div class="col-12 form-group form-group-sm">
    <div class="card">
      <div class="card-body">
        <label class="label" for="vehiculo"
          >Acciones para contrato del cliente</label
        >
        <div class="d-flex justify-content-around">
          <div class="btn-group btn-group-md">
            <button
              @click="$bvModal.show('migrarContrato')"
              class="btn btn-primary"
            >
              Migrar contrato a...
            </button>
          </div>
          <div class="btn-group btn-group-md">
            <button
              @click="$bvModal.show('MantenimientoContratoModal')"
              class="btn btn-warning"
            >
              Mantenimiento
            </button>
          </div>
          <div class="btn-group btn-group-md">
            <button
              @click="$bvModal.show('BajaContratoModal')"
              class="btn btn-danger"
            >
              Baja
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AccionesContrato",
};
</script>
